"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const has_1 = __importDefault(require("lodash/has"));
const formik_1 = require("formik");
const Table_1 = __importDefault(require("@mui/material/Table"));
const TableBody_1 = __importDefault(require("@mui/material/TableBody"));
const TableRowContext_1 = require("@/components/DynamicTable/TableRowContext");
const DyanmicTableHead_1 = __importDefault(require("@/components/DynamicTable/DyanmicTableHead"));
const DynamicTableRow_1 = __importDefault(require("@/components/DynamicTable/DynamicTableRow"));
const SimpleCell_1 = __importDefault(require("@/components/DynamicTable/Cells/SimpleCell"));
const AutocompleteField_1 = __importDefault(require("@/components/AutocompleteField"));
const DeletableCell_1 = __importDefault(require("@/components/DynamicTable/Cells/DeletableCell"));
const constants_1 = require("./constants");
const SetRangeValueField_1 = __importDefault(require("../SetRangeValueField"));
const SystemComponentsPrompt_1 = __importDefault(require("../SystemComponentsPrompt"));
const SystemsToast_1 = __importDefault(require("../SystemsToast"));
const RemoveSystemComponentAssociationDialog_1 = __importDefault(require("../RemoveSystemComponentAssociationDialog"));
const style_1 = require("./style");
function AssociationTable({ componentRowInputs, errors, selectComponentOptions, onDelete, onToggleSavePrompt, }) {
    const onChange = react_1.default.useCallback((arrayHelpers, index) => async (event, value, reason) => {
        if (reason === "clear") {
            arrayHelpers.form.setFieldValue(`systemComponents[${index}]`, null);
            return;
        }
        const newValue = {
            name: value?.name,
            id: value?.id,
            unit: value?.unit,
            range: {
                lowLimitValue: value?.range.lowLimitValue,
                highLimitValue: value?.range.highLimitValue,
            },
            order: value?.order,
        };
        arrayHelpers.form.setFieldValue(`systemComponents[${index}]`, {
            ...newValue,
        });
        if (index === arrayHelpers.form.values["systemComponents"].length - 1)
            arrayHelpers.push({
                name: "Select Component",
                id: "-",
                unit: "-",
                order: 0,
                range: { lowLimitValue: undefined, highLimitValue: undefined },
            });
    }, []);
    const onDeleteComponent = react_1.default.useCallback((arrayHelpers, componentToBeUnlinked, index) => () => {
        if (onDelete) {
            onDelete(componentToBeUnlinked, index);
        }
        else {
            arrayHelpers.remove(index);
        }
    }, [onDelete]);
    return (react_1.default.createElement(formik_1.Form, null,
        react_1.default.createElement(formik_1.FieldArray, { name: "systemComponents" }, (arrayHelpers) => {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(style_1.ScrollableTableContainer, { sx: { overflowX: "initial" } },
                    react_1.default.createElement(Table_1.default, { stickyHeader: true, sx: { height: "fit-content" } },
                        react_1.default.createElement(DyanmicTableHead_1.default, { tableHeadCells: constants_1.tableHeadCells }),
                        react_1.default.createElement(TableBody_1.default, null,
                            react_1.default.createElement(TableRowContext_1.TableRowProvider, { fieldArrayName: "systemComponents", arrayHelpers: arrayHelpers }, componentRowInputs["systemComponents"]?.map((row, index) => {
                                let errorMessage = "";
                                if (errors?.systemComponents &&
                                    (0, has_1.default)(errors?.systemComponents, index)) {
                                    errorMessage = errors?.systemComponents[index];
                                }
                                else {
                                    errorMessage = "";
                                }
                                return (react_1.default.createElement(DynamicTableRow_1.default, { key: `${row?.id}-${index}` },
                                    react_1.default.createElement(SimpleCell_1.default, { variant: "body", align: "left", onClick: onToggleSavePrompt },
                                        react_1.default.createElement(AutocompleteField_1.default, { name: `systemComponents[${index}].name`, options: selectComponentOptions, autocompleteStyles: style_1.AutoCompleteStyle, value: componentRowInputs["systemComponents"][index]
                                                ?.name ||
                                                "", id: "systemComponents", placeholder: "Select Component", error: !!errorMessage, getOptionLabel: (option) => {
                                                if (typeof option === "string") {
                                                    return option;
                                                }
                                                if (typeof option === "string" &&
                                                    option === "") {
                                                    return "";
                                                }
                                                return option?.name;
                                            }, helperText: errorMessage, isOptionEqualToValue: (option, value) => {
                                                if (value?.name) {
                                                    return option?.name === value?.name;
                                                }
                                                if (typeof value === "string") {
                                                    return (value === option?.name ||
                                                        value === "Select Component");
                                                }
                                                return true;
                                            }, onFocus: arrayHelpers.form.handleBlur, onBlur: arrayHelpers.form.handleBlur, onChange: onChange(arrayHelpers, index), inputStyles: style_1.InputStyle }),
                                        " "),
                                    react_1.default.createElement(SimpleCell_1.default, { variant: "body", onClick: onToggleSavePrompt, align: "left", size: "small" },
                                        react_1.default.createElement(SetRangeValueField_1.default, { lowLimitValue: row?.range?.lowLimitValue, highLimitValue: row?.range?.highLimitValue, nameLowLimitValue: `systemComponents[${index}].range.lowLimitValue`, nameHighLimitValue: `systemComponents[${index}].range.highLimitValue`, onSetLowLimitValue: arrayHelpers.form.handleChange, onSetHighLimitValue: arrayHelpers.form.handleChange })),
                                    react_1.default.createElement(SimpleCell_1.default, { variant: "body", align: "left" },
                                        react_1.default.createElement(react_1.default.Fragment, null, row?.unit)),
                                    react_1.default.createElement(DeletableCell_1.default, { align: "right", disabled: index ===
                                            arrayHelpers.form.values["systemComponents"]
                                                .length -
                                                1, onDelete: onDeleteComponent(arrayHelpers, componentRowInputs["systemComponents"][index], index) })));
                            }))))),
                react_1.default.createElement(SystemComponentsPrompt_1.default, null),
                react_1.default.createElement(SystemsToast_1.default, null),
                react_1.default.createElement(RemoveSystemComponentAssociationDialog_1.default, { arrayHelpers: arrayHelpers })));
        })));
}
exports.default = AssociationTable;
